import React, {memo} from 'react'
import Button from '@material-ui/core/Button';

const AppButton = memo(({label, type, size, style = null, onClick}) => {
    return (
        <Button
            style={style}
            type={type}
            onClick={onClick}
            variant="contained"
            size={size}
            color="secondary">
            {label}
        </Button>
    );
})
export default AppButton